var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"w-10 mr-8",attrs:{"src":require("../../assets/images/footerLogo.svg"),"alt":"Logo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }